import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Alert } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { clearAllCache } from "../../../utils/apiCache";


const AdmissionLogin = () => {
    const routes = all_routes;
    const navigation = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [school_id, setSchoolId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [error1, setError1] = useState('');
    const [error2, setError2] = useState('');
    const [error3, setError3] = useState('');
    const authToken = localStorage.getItem("token");
    const [Automationdata, setAutomationdata] = useState();

    const [admissionNo, setAdmissionNo] = useState('');
    const [otp, setOtp] = useState('');
    const [step, setStep] = useState(1);
    const [timer, setTimer] = useState(120);
    const [canResend, setCanResend] = useState(false);
    const [showAdmissionLogin, setShowAdmissionLogin] = useState(false);


    const fetchSchoolAutomationData = async () => {
        try {
            const response = await axios.get(
                "https://api.mirai.healthcare/api/head/school-rule/school-automation",
                {
                    headers: {
                        accept: "application/json",
                    },
                }
            );
            if (response?.data) {
                setAutomationdata(response?.data?.[0]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        clearAllCache();
        fetchSchoolAutomationData();
    }, []);

    const fetchAdmissionPermission = async () => {
        try {
            const response = await axios.get(
                "https://api.mirai.healthcare/api/user/service-permission/filter?module_code=LOGIN-ADMISSION-NUMBER",
                {
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                        "x-auth": authToken,
                    },
                }
            );

            // ✅ agar data hai to show karo
            if (response?.data && response?.data?.data?.length > 0) {
                setShowAdmissionLogin(true);
            } else {
                setShowAdmissionLogin(false);
            }
        } catch (error) {
            console.log(error);
            setShowAdmissionLogin(false);
        }
    };

    useEffect(() => {
        fetchAdmissionPermission();
    }, []);

    const schoolName = Automationdata?.schoolName;
    const schoolLogo = Automationdata?.schoolLogo;

    const handleSendOtp = async (e) => {
        e.preventDefault();

        if (!admissionNo) {
            // setError1("Please enter Admission Number");
            Swal.fire({
                title: "warning",
                icon: "warning",
                text: "Please enter Admission Number"
            });
            return;
        }


        try {
            setLoading(true);

            const response = await axios.post(
                "https://api.mirai.healthcare/api/student/admission-num/otp-send",
                {
                    admission_no: admissionNo.trim(),
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-auth": authToken,
                    },
                }
            );

            if (response?.data) {
                alert("OTP sent successfully");
                setStep(2);

                // ✅ reset timer
                setTimer(120);
                setCanResend(false);
            }
        } catch (error) {
            console.error(error);
            alert("Failed to send OTP");
        } finally {
            setLoading(false);
        }
    };

    const handleResendOtp = async () => {
        if (!canResend) return;

        try {
            setLoading(true);

            const response = await axios.post(
                "https://api.mirai.healthcare/api/student/admission-num/otp-send",
                {
                    admission_no: admissionNo.trim(),
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-auth": authToken,
                    },
                }
            );

            if (response?.data) {
                alert("OTP resent successfully");

                // reset timer again
                setTimer(120);
                setCanResend(false);
            }
        } catch (error) {
            console.error(error);
            alert("Failed to resend OTP");
        } finally {
            setLoading(false);
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();

        if (!otp) {
            alert("Please enter OTP");
            return;
        }

        try {
            setLoading(true);

            const response = await axios.post(
                "https://api.mirai.healthcare/api/student/admission-num/verify-otp",
                {
                    admission_no: admissionNo,
                    otp: otp,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-auth": authToken,
                    },
                }
            );

            // ✅ axios me data yaha milta hai
            const data = response?.data;

            // ✅ success check (status 200)
            if (response.status === 200) {
                clearAllCache();
                localStorage.setItem("token", data?.message?.token);
                localStorage.setItem("siblings", JSON.stringify(data?.message?.siblings));

                // React Native WebView support
                if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                            type: "LOGIN_SUCCESS",
                            token: data?.message?.token,
                        })
                    );
                }

                // ✅ Redirect
                window.location.href = "/";
            } else {
                alert(data?.message || "OTP verification failed");
            }

        } catch (error) {
            console.error(error);
            alert(error?.response?.data?.message || "Invalid OTP");
        } finally {
            setLoading(false);
        }
    };


    const [passwordVisibility, setPasswordVisibility] = useState({
        password: false,
    });

    const togglePasswordVisibility = (field) => {
        setPasswordVisibility((prevState) => ({
            ...prevState,
            [field]: !prevState[field],
        }));
    };

    useEffect(() => {
        const handleBackButton = (event) => {
            event.preventDefault();
            navigation("/");
        };

        window.history.pushState(null, null, window.location.href);
        window.addEventListener("popstate", handleBackButton);

        return () => {
            window.removeEventListener("popstate", handleBackButton);
        };
    }, [navigation]);

    useEffect(() => {
        let interval;

        if (step === 2 && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setCanResend(true);
        }

        return () => clearInterval(interval);
    }, [timer, step]);


    return (
        <>
            <div className="container-fuild">
                <div className="login-wrapper w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="d-lg-flex align-items-center justify-content-center bg-light-300 d-lg-block d-none flex-wrap vh-100 overflowy-auto bg-01">
                                <div>
                                    <ImageWithBasePath
                                        src="assets/img/authentication/authentication-06.svg"
                                        alt="Img"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap ">
                                <div className="col-md-8 mx-auto p-4">
                                    <form onSubmit={step === 1 ? handleSendOtp : handleVerifyOtp}>
                                        <div>
                                            <div className=" mx-auto mb-5 text-center">
                                                <img src={schoolLogo} className="img-fluid logo_css"
                                                    alt="Logo" />
                                            </div>
                                            <div className="card">
                                                <div className="card-body p-4">
                                                    <div className=" mb-4 text-center">
                                                        <h2 className="mb-2">Welcome</h2>
                                                        <p className="mb-0">
                                                            Please enter your details to sign in
                                                        </p>
                                                    </div>

                                                    <div className="mb-3">


                                                        <label className="form-label">Admission Number</label>
                                                        <div className="input-icon mb-3 position-relative">
                                                            <span className="input-icon-addon">
                                                                <i className="ti ti-text" />
                                                            </span>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={admissionNo}
                                                                placeholder="Enter Admission Number"
                                                                onChange={(e) => setAdmissionNo(e.target.value)}
                                                            />
                                                            {error1 && <p className="dangerColor">{error1}</p>}
                                                        </div>
                                                        {step === 2 && (

                                                            <p>
                                                                {!canResend ? (
                                                                    <p>Resend OTP
                                                                        <span style={{ float: 'right' }}><strong>{timer}s</strong></span>
                                                                    </p>
                                                                ) : (
                                                                    <span style={{ float: 'right' }}>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-link p-0"
                                                                            onClick={handleResendOtp}
                                                                            style={{ fontWeight: "600" }}
                                                                        >
                                                                            Resend OTP
                                                                        </button>
                                                                    </span>

                                                                )}
                                                            </p>

                                                        )}

                                                        {step === 2 && (
                                                            <>
                                                                <label className="form-label">Enter OTP</label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control mb-3"
                                                                    placeholder="Enter OTP"
                                                                    value={otp}
                                                                    onChange={(e) => setOtp(e.target.value)}
                                                                />
                                                            </>
                                                        )}
                                                    </div>


                                                    <div className="mb-3">
                                                        {/* <button
                                                            type="submit"
                                                            className="btn btn-primary w-100"
                                                            disabled={loading}
                                                        >
                                                            {step === 1 ? "Send OTP" : "Verify OTP"}
                                                        </button> */}
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary w-100"
                                                            disabled={loading}
                                                        >
                                                            {loading
                                                                ? (step === 1 ? "Sending..." : "Verifying...")
                                                                : (step === 1 ? "Send OTP" : "Verify OTP")
                                                            }
                                                        </button>

                                                    </div>
                                                    <div className="text-center">
                                                                                <h6 className="fw-normal text-dark mb-0">
                                                                                  Don’t have an account?{" "}
                                                                                  <Link to={routes.createenquiry} className="hover-a ">
                                                                                    {" "}
                                                                                    Create Enquiry
                                                                                  </Link>
                                                                                </h6>
                                                                              </div>


                                                    <div className="text-center mt-2">
                                                        <div className="d-flex align-items-center mb-3">
                                                            <hr className="flex-grow-1" />
                                                            <span className="mx-2 text-muted">OR</span>
                                                            <hr className="flex-grow-1" />
                                                        </div>

                                                        <Link
                                                            to={routes.login}
                                                            className="btn w-100"
                                                            style={{
                                                                background: "rgb(49.0717821782, 84.3737623762, 223.2282178218)",
                                                                color: "#fff",
                                                                borderRadius: "12px",
                                                                padding: "10px",
                                                                fontWeight: "600",
                                                                boxShadow: "0 4px 10px rgba(0,0,0,0.1)"
                                                            }}
                                                        >
                                                            Login with User Name & Password
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mt-5 text-center">
                                                <p className="mb-0 ">Copyright © 2025 - Erish</p>
                                            </div>
                                        </div>
                                    </form>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdmissionLogin